module.exports = __webpack_public_path__ + "place-blue.png?a475808b70ad2f87c07a7f75b5ba8ca7";


//////////////////
// WEBPACK FOOTER
// ./images/place-blue.png
// module id = 174
// module chunks = 0